__turbopack_context__.v({
  "actionIcon": "CElectronicSigns-module__cvO_5q__actionIcon",
  "actions": "CElectronicSigns-module__cvO_5q__actions",
  "docName": "CElectronicSigns-module__cvO_5q__docName",
  "note": "CElectronicSigns-module__cvO_5q__note",
  "pageButton": "CElectronicSigns-module__cvO_5q__pageButton",
  "pageInfo": "CElectronicSigns-module__cvO_5q__pageInfo",
  "pagination": "CElectronicSigns-module__cvO_5q__pagination",
  "previewBtn": "CElectronicSigns-module__cvO_5q__previewBtn",
  "root": "CElectronicSigns-module__cvO_5q__root",
  "searchWrap": "CElectronicSigns-module__cvO_5q__searchWrap",
  "signBtn": "CElectronicSigns-module__cvO_5q__signBtn",
  "signMuted": "CElectronicSigns-module__cvO_5q__signMuted",
  "sortIcon": "CElectronicSigns-module__cvO_5q__sortIcon",
  "sortIconActive": "CElectronicSigns-module__cvO_5q__sortIconActive",
  "table": "CElectronicSigns-module__cvO_5q__table",
  "tableWrap": "CElectronicSigns-module__cvO_5q__tableWrap",
  "thInner": "CElectronicSigns-module__cvO_5q__thInner",
  "thSortable": "CElectronicSigns-module__cvO_5q__thSortable",
  "toolbar": "CElectronicSigns-module__cvO_5q__toolbar",
  "truncatedHint": "CElectronicSigns-module__cvO_5q__truncatedHint",
});
